<template>
    <div>
        <vs-card title="Background Putaway" class="p-4 mb-6">
            <div slot="header" class="flex flex-wrap items-center justify-between">
                <div class="flex items-center">
                    <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                    <h4 style="margin-left: 10px">Background Putaway</h4>
                </div>
                <div class="flex items-center">
                    <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm">Save Putaway</vs-button>
                </div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col md:w-1/3 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" label="Gr id" v-model="gr_id" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" label="Gr Reference" v-model="gr_reference" disabled/>
                        </div>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" label="Movement ID" v-model="movement_id" disabled/>
                        </div>
                    </div>

                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-full">
                            <label for="" class="vs-input--label">Movement Date *</label>
                            <flat-pickr class="w-full" v-model="movement_date"/>
                        </div>
                    </div>
                </div>
            </div>
        </vs-card>
        <vs-card title="Item Details" class="p-4 mb-6">
                <vs-table multiple v-model="selected" :data="drafts" stripe>
                    <template slot="thead">
                        <vs-th>Line ID</vs-th>
                        <vs-th>Product ID</vs-th>
                        <vs-th>Description</vs-th>
                        <vs-th>Pack ID</vs-th>
                        <vs-th>Batch</vs-th>
                        <vs-th>Exp. Date</vs-th>
                        <vs-th>Qty</vs-th>
                        <vs-th>UoM</vs-th>
                        <vs-th>Stock Type</vs-th>
                        <vs-th>Location Type</vs-th>
                        <vs-th>Location ID</vs-th>
                        <vs-th>Storage Unit</vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td :data="data[indextr].line_id">
                            {{ indextr+1 }}
                        </vs-td>

                        <vs-td :data="data[indextr].line_id">
                            {{ data[indextr].product_code }}
                        </vs-td>

                        <vs-td :data="data[indextr].line_id">
                            {{ data[indextr].description_1 }}
                        </vs-td>

                        <vs-td :data="data[indextr].line_id">
                            {{ data[indextr].pack_id }}
                        </vs-td>

                        <vs-td :data="data[indextr].line_id">
                            {{ data[indextr].batch }}
                        </vs-td>

                        <vs-td :data="data[indextr].line_id">
                            {{ data[indextr].expired_date }}
                        </vs-td>
                        
                        <vs-td :data="data[indextr].line_id">
                            {{ data[indextr].base_qty}}
                        </vs-td>

                        <vs-td :data="data[indextr].line_id">
                            {{ data[indextr].base_uom_name }}
                        </vs-td>

                        <vs-td :data="data[indextr].line_id">
                            {{ data[indextr].stock_type_name }}
                        </vs-td>

                        <vs-td :data="data[indextr].line_id">
                            {{ data[indextr].location_type_code }}
                        </vs-td>

                        <vs-td :data="data[indextr].line_id">
                            {{ data[indextr].location_code }}
                        </vs-td>

                        <vs-td :data="data[indextr].line_id">
                            {{ data[indextr].storage_unit }}
                        </vs-td>

                        </vs-tr>
                    </template>
                </vs-table>
        </vs-card>
    </div>  
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    components:{
        flatPickr,
    },
    data() {
        return {
            isLoading:false,
            selected: [],
            data: [],
            drafts: [],
            gr_id:'',
            gr_reference: '',
            movement_id:'',
            movement_date: new Date()
        }
    },
    watch:{
        isLoading: function(){
            if(this.isLoading){
                this.$vs.loading()
            }
            else{
                this.$vs.loading.close()
            }
        }
    },
    methods: {
        fetchData() {
            const dataSend = {
                good_receive: JSON.stringify({id:this.$route.params.id})
            }

            this.$http.post('putaway/background/draftputaway', dataSend)
            .then(res => {
                this.gr_id = this.$route.params.id;
                this.gr_reference = res.data.data_gr.gr_reference;
                this.data = res.data.list_draftputaway
                const drafts = []
                let lineid = 1
                res.data.list_draftputaway.map(item => {
                    if(drafts.length == 0) {
                        drafts.push({...item, line_id: lineid})
                    }
                    else {
                        let found = false
                        let index = null
                        
                        for(let i = 0; i < drafts.length; i++) {
                            if(drafts[i].location_id == item.location_id) {
                                if(drafts[i].product_code == item.product_code && drafts[i].pack_id == item.pack_id && drafts[i].batch == item.batch && drafts[i].expired_date == item.expired_date && drafts[i].stock_type_name == item.stock_type_name) {
                                    found = true
                                    index = i
                                    // drafts[i].base_qty += item.base_qty
                                }
                            }
                        }

                        if(found) {
                            drafts[index].base_qty += item.base_qty
                        }
                        else {
                            drafts.push({...item, line_id: lineid})                                
                        }
                    }

                    lineid++
                })
                this.drafts = drafts
                this.isLoading = false
            })
            .catch((error) => {
                const message = error.response.data.message ? error.response.data.message : 'Something went wrong.'
              this.$router.push({
                  name: 'good-receive-view',
                  params: {
                      id: this.$route.params.id
                  }
              })
                this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: message
                    })
            })

         // this.$http.post('putaway/background/draftputaway', dataSend)
         //    .then(res => {
         //        this.gr_id = this.$route.params.id;
         //        this.gr_reference = res.data.data_gr.gr_reference;
         //        res.data.list_draftputaway.map(item => {
         //            this.drafts.push(item)
         //            // if(item.inventory_first_id) {
         //            //     this.selected.push(item)
         //            // }
         //        })
         //    })
         //    .catch(error => console.log(error))
        },
        back() {
            this.$vs.dialog({
                color: 'warning',
                title: 'Leave Page',
                text: 'Changes you made may not be saved?',
                acceptText: 'Leave Page',
                accept: () => this.$router.push({ name: 'good-receive-view', params: {id: this.$route.params.id} }),
            })
        },

        submitForm() {
            let error = false
            const moHead = {
                gr_id: this.$route.params.id,
                movement_date: this.movement_date
            }

            let details = []

            if(this.drafts.length <= 0) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: 'Detail is empty'
                })
                return false
            }
            this.isLoading = true ;
            this.drafts.map((item, index) => {
                if(!item.location_id) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Line ' + item.line_id + '. No location assigned'
                    })
                    error = true
                }
                else {
                    details.push({
                        line_id: index+1,
                        grd_id: item.grd_id,
                        draft_id: item.id,
                        movement_date: this.movement_date,
                        base_qty: item.base_qty,
                        location_id: item.location_id,
                        dest_storage_unit:  item.storage_unit,
                        inventories_first_id:  item.inventory_first_id,
                    })
                }
            })

            if(error) {
                this.isLoading = false;
                return false
            }
            else {
                const dataSend = {
                    movement_order: JSON.stringify(moHead),
                    movement_order_details: JSON.stringify(details)
                }

                this.$http.post('putaway/background/store', dataSend)
                .then(() => {
                    this.isLoading = false ;
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        iconPack: 'feather',
                        icon:'icon-check',
                        text: 'Saved successfully'
                    })
                    this.$router.push({ name: 'good-receive-view', params: {id: this.$route.params.id} })
                })
                .catch(() => {
                    this.isLoading = false ;
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Something went wrong'
                    })
                })
            }
        }
    },
    mounted() {
        this.isLoading = true ;
        if(this.isLoading){
            this.$vs.loading()
        }
        this.fetchData()
    }
}
</script>